<template>
  <div class="apply-card flex-align" :class="cardType">
    <div
      class="apply-card__button flex-center"
      :class="cardType"
      @click="handleClick"
    >
      {{ text }}
    </div>
    <div v-if="leftTime" class="apply-card__content">剩余{{ leftTime }}</div>
    <div v-if="startTime && endTime && timeLeftMillisecond">
      {{ distanceTime }}
    </div>
  </div>
</template>

<script>
import DateUtils from '@/utils/date'

export default {
  name: 'ApplyEntry',

  // 自定义函数 requestAgain (没有返回参数）
  // 在倒计时为0的时候触发
  props: {
    // 状态 true:primary, false:danger
    // 1:未开始，2：报名状态，3：结束状态
    status: {
      type: [Number, String],
      default: 1,
      require: true
    },

    // 展示的文字
    text: {
      type: String,
      default: ''
    },

    // 剩余时间 (不需要倒计时的情况）
    leftTime: {
      type: String,
      default: ''
    },

    // 开始时间 （需要倒计时的情况）
    startTime: {
      type: String,
      default: ''
    },

    // 结束时间（需要倒计时的情况）
    endTime: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      dateUtils: new DateUtils(), // 倒计时操作的类实例化
      timeLeftMillisecond: 0 // 倒计时的毫秒
    }
  },

  computed: {
    cardType() {
      if (Number(this.status) === 1) {
        return 'primary'
      } else if (Number(this.status) === 2) {
        return 'success'
      } else if (Number(this.status) === 3) {
        return 'danger'
      } else {
        return ''
      }
    },

    // 距离竞价开始的时间文字倒计时
    distanceTime() {
      const temp = DateUtils.formatDuring(this.timeLeftMillisecond)

      return `${temp.days}天${temp.hours}时${temp.minutes}分${Math.round(
        temp.seconds
      )}秒`
    }
  },

  watch: {
    startTime(val) {
      this.getCountDownTime()
    },
    endTime(val) {
      this.getCountDownTime()
    },

    timeLeftMillisecond() {
      if (this.timeLeftMillisecond <= 0) {
        this.$emit('requestAgain')
      }
    }
  },

  created() {
    this.getCountDownTime()
  },

  beforeDestroy() {
    this.dateUtils.stopCountDown()
  },

  methods: {
    getCountDownTime() {
      if (!this.startTime || !this.endTime) {
        this.dateUtils.stopCountDown()
        return
      }

      this.dateUtils.countTimeDown(
        this.startTime || 0,
        this.endTime || 0,
        ms => (this.timeLeftMillisecond = ms)
      )
    },
    handleClick() {
      this.status && this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.apply-card {
  min-width: pixel-to-rem($n: 290);
  height: pixel-to-rem($n: 70);
  padding: 0 pixel-to-rem($n: 18);

  color: $white-color;
  border-radius: pixel-to-rem($n: 8) 0 0 pixel-to-rem($n: 8);

  &.primary {
    background: $primary-color;
  }

  &.danger {
    color: $danger-color;
    background: $danger-color;
  }

  &.success {
    color: $success-color;
    background: $success-color;
  }

  .apply-card__button {
    width: pixel-to-rem($n: 96);
    height: pixel-to-rem($n: 34);
    background-color: $white-background-color;
    font-size: pixel-to-rem($n: 18);
    border-radius: pixel-to-rem($n: 4);
    margin-right: pixel-to-rem($n: 14);
    cursor: pointer;

    &.primary {
      color: $primary-color;
    }

    &.danger {
      color: $danger-color;
    }
  }

  .apply-card__content {
    font-size: pixel-to-rem($n: 20);
  }
}
</style>
